import {
  USER_CONNECTED_FETCH
} from '../constants/ActionTypes';

const initialState = {};
export default (state = initialState, action) => {
  switch (action.type) {
    case USER_CONNECTED_FETCH:
      return action.user;
    default:
      return state;
  }
};